import { ListItem, ListItemText, Stack, Tooltip, Typography } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { useMemo } from "react";
import { prettyPrintDateTimeWithSeconds } from "util/dates";

import { gql } from "../../generated-graphql";
import { CommentListFragment } from "../../generated-graphql/graphql";

gql(`
  fragment CommentList on Comment {
    id
    reportId
    userId
    workflowId
    activityId
    comment
    updatedAt
    updatedBy
    user {
      id
      email
    }
  }
`);

interface CommentsListProps {
  comments: CommentListFragment[];
  showNewestOnTop?: boolean;
}

export function CommentList({ comments, showNewestOnTop = true }: CommentsListProps) {
  const sortedComments = useMemo(() => {
    return [...comments].sort((a, b) => {
      return showNewestOnTop
        ? new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        : new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime();
    });
  }, [comments, showNewestOnTop]);
  return (
    <>
      <Stack
        sx={{
          maxHeight: "15rem",
          overflowY: "auto",
          wordWrap: "break-word",
        }}
      >
        {sortedComments.map((comment) => (
          <ListItem
            key={comment.id}
            divider={true}
            sx={{
              paddingTop: "0.0625rem",
              paddingBottom: "0.0625rem",
            }}
          >
            <ListItemText>
              <Typography variant="subtitle2">
                <strong>{comment?.user?.email ?? comment?.updatedBy ?? "Someone"} </strong>
                <Tooltip title={prettyPrintDateTimeWithSeconds(comment.updatedAt)}>
                  <span>{formatDistanceToNow(new Date(comment.updatedAt)) + " ago"}</span>
                </Tooltip>
              </Typography>
              <Typography style={{ whiteSpace: "pre-wrap" }}>{comment.comment}</Typography>
            </ListItemText>
          </ListItem>
        ))}
      </Stack>
    </>
  );
}
